import axios from "axios"
import {
     CONST_API_DOCUMENTS_EMBAUCHE_CONFIG_ENDPOINT,
     CONST_API_DOCUMENTS_EMBAUCHE_UPLOAD_ENDPOINT,
     CONST_API_DOCUMENTS_EMBAUCHE_REPLACE_ENDPOINT,
     CONST_API_DOCUMENTS_EMBAUCHE_RENAME_ENDPOINT,
     CONST_API_DOCUMENTS_EMBAUCHE_DELETE_ENDPOINT,
} from "../../../endpoints"

// Taille maximale d'un document d'embauche : 2 Mo (aligné sur le backend).
export const DOCUMENT_EMBAUCHE_MAX_SIZE = 2 * 1024 * 1024

export interface IDocumentEmbaucheFileModel {
     id: string
     title: string | null
     fileName: string | null
     mimeType: string | null
     size: number | null
     modifiedTime: string | null
     createdBy?: string | null
     createdAt?: string | null
     tracked?: boolean
}

export interface IDocumentsEmbaucheStatutModel {
     statut: string // "ETAM" | "CADRE"
     statutLabel: string
     folderId: string | null
     configured: boolean
     documents: IDocumentEmbaucheFileModel[]
}

export interface IDocumentsEmbaucheEntiteModel {
     key: string
     label: string
     statuts: IDocumentsEmbaucheStatutModel[]
}

export interface IDocumentsEmbaucheConfigResponse {
     entites: IDocumentsEmbaucheEntiteModel[]
}

export function documentsEmbaucheConfigRequest() {
     return axios.get<IDocumentsEmbaucheConfigResponse>(CONST_API_DOCUMENTS_EMBAUCHE_CONFIG_ENDPOINT)
}

export function documentsEmbaucheUploadRequest(entityKey: string, statut: string, title: string, fichier: File) {
     const formData = new FormData()
     formData.append("entityKey", entityKey)
     formData.append("statut", statut)
     formData.append("title", title)
     formData.append("fichier", fichier)
     return axios.post<IDocumentEmbaucheFileModel>(CONST_API_DOCUMENTS_EMBAUCHE_UPLOAD_ENDPOINT, formData)
}

// Remplace un document (même titre) : nouveau fichier, l'ancien est marqué comme supprimé.
export function documentsEmbaucheReplaceRequest(entityKey: string, statut: string, fileId: string, fichier: File) {
     const formData = new FormData()
     formData.append("entityKey", entityKey)
     formData.append("statut", statut)
     formData.append("fileId", fileId)
     formData.append("fichier", fichier)
     return axios.post<IDocumentEmbaucheFileModel>(CONST_API_DOCUMENTS_EMBAUCHE_REPLACE_ENDPOINT, formData)
}

// Change le titre d'un document.
export function documentsEmbaucheRenameRequest(entityKey: string, statut: string, fileId: string, title: string) {
     return axios.post<IDocumentEmbaucheFileModel>(CONST_API_DOCUMENTS_EMBAUCHE_RENAME_ENDPOINT, { entityKey, statut, fileId, title })
}

export function documentsEmbaucheDeleteRequest(entityKey: string, statut: string, fileId: string) {
     return axios.post(CONST_API_DOCUMENTS_EMBAUCHE_DELETE_ENDPOINT, { entityKey, statut, fileId })
}
